var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaselineClose24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2195",
    d: "M0 0h32v32H0z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 8195",
    fill: "#00000e"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 3487",
    d: "M8.126 22.123L22.125 8.124l1.75 1.75-13.999 14z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 3493",
    d: "M9.875 8.126l13.999 13.999-1.75 1.75-14-13.999z"
  }))));
}
export default SvgBaselineClose24Px;